import { X } from 'lucide-react';
import React from 'react';

interface SidebarPanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  width?: 'sm' | 'md' | 'lg' | 'xl';
  headerColor?: string;
  headerTextColor?: string;
}

const SidebarPanel: React.FC<SidebarPanelProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  children,
  width = 'lg',
  headerColor = 'bg-teal-500',
  headerTextColor = 'text-white'
}) => {
  const widthClasses = {
    sm: 'w-80',
    md: 'w-96',
    lg: 'w-[32rem]', // 512px
    xl: 'w-[40rem]'  // 640px
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className={`fixed inset-0 bg-black z-40 transition-opacity duration-300 ease-in-out ${
          isOpen ? 'bg-opacity-50 opacity-100' : 'bg-opacity-0 opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />
      
      {/* Sidebar */}
      <div className={`fixed right-0 top-0 h-full ${widthClasses[width]} bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        {/* Header */}
        <div className={`flex items-center justify-between p-4 border-b border-gray-200 ${headerColor} ${headerTextColor}`}>
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-black hover:bg-opacity-10 rounded-md transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto h-full pb-16">
          {children}
        </div>
      </div>
    </>
  );
};

export default SidebarPanel;
